import MMLogo from '@/assets/branding/mentalmatters/MM-Logo.png';

const colors = {
  // Brand colors
  brand_primary: '#774C23',
  brand_primary_hover: '#5E3A1B', // −10 L, −8 S
  brand_primary_highlight: '#B87B3F', // +23 L, +7 S
  brand_primary_mid: '#916135', // +8 L,  +2 S
  brand_primary_dark: '#3D2410', // −25 L, −3 S (clamped)
  brand_secondary: '#725335', // hue +4°, −15 L, −13 S
  brand_accent_start: '#8B5D33',
  brand_accent_end: '#B58A2F',
  brand_accent_light_start: '#F8EFE8',
  brand_accent_light_end: '#F6EDD8',
  brand_complementary_accent: 'rgb(34,114,191)',
  brand_auth_gradient_mid: '#725335',
  brand_auth_gradient_end: '#3D2410',
  brand_auth_warp_mid: '#916135',
};

export default {
  name: 'Mental Matters',
  isSAML: true,
  allowPersonalCourses: false,
  logo: MMLogo,
  colors,
};
